import React, { useState } from 'react';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const [jsonInput, setJsonInput] = useState('');
  const [apiResponse, setApiResponse] = useState(null);

  const handleJsonChange = (event) => {
    setJsonInput(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('http://app.sam-uday.in:8080/api/tokenize/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: jsonInput,
      });
      const result = await response.json();
      setApiResponse(result);
    } catch (error) {
      setApiResponse({ error: 'Failed to connect to the API' });
    }
  };

  return (
    <div className="dashboard">
      <header className="header">
        <div className="logo">Samuday Developer Portal</div>
        <nav>
          <a href="/dashboard">Dashboard</a>
          <a href="/logout">Logout</a>
        </nav>
      </header>

      <div className="dashboard-content">
        <aside className="sidebar">
          <ul>
            <li><a href="#tokenize">Tokenize API</a></li>
          </ul>
        </aside>
        <main className="main-content">
          <h2>Tokenize API</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="json-input">Enter JSON Payload:</label>
            <textarea
              id="json-input"
              value={jsonInput}
              onChange={handleJsonChange}
              placeholder="{ 'key': 'value' }"
            ></textarea>
            <button type="submit">Send Request</button>
          </form>
          {apiResponse && (
            <div className="response">
              <h3>API Response:</h3>
              <pre>{JSON.stringify(apiResponse, null, 2)}</pre>
            </div>
          )}
        </main>
      </div>

      <footer className="footer">
        <p>&copy; 2024 Samuday Technology Services. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default Dashboard;
